<template>
  <div class="home-page">
      <div class="logo">
        <svg class="jsx-2263963463 artboard sayes-logo"><svg viewBox="0 -47 362.87859824780975 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="jsx-2263963463 artboard-inner" style="width: 132px; height: 36.3758px; max-height: 100%;"><g transform="translate(-5.5068836045056315 51.998748435544414) scale(1.7382839660686966)" fill="#F3EEE0"><g id="line1"><path d="M34.632-45.792C32.256-51.624 26.568-55.656 20.160-55.656C15.912-55.656 12.312-54.144 9.216-51.048C6.120-48.024 4.608-44.352 4.608-40.104C4.608-36.072 5.976-32.616 8.640-29.664C11.376-26.784 14.760-25.128 18.720-24.768C22.968-24.408 25.920-21.240 25.920-17.208C25.920-13.104 22.608-9.720 18.504-9.720C15.408-9.720 13.176-11.160 11.808-14.040L12.888-14.688C13.896-12.240 15.768-11.016 18.504-11.016C21.888-11.016 24.624-13.824 24.624-17.208C24.624-20.448 21.960-23.184 18.720-23.472C14.472-23.832 10.800-25.560 7.848-28.728C4.896-31.968 3.384-35.712 3.384-40.104C3.384-44.784 5.040-48.744 8.280-51.984C11.520-55.296 15.480-56.952 20.160-56.952C27.072-56.952 33.120-52.632 35.712-46.512ZM30.096-43.200C28.728-47.520 24.768-50.472 20.160-50.472C17.352-50.472 14.904-49.464 12.816-47.376C10.800-45.360 9.792-42.912 9.792-40.104C9.792-37.440 10.728-35.064 12.528-33.120C14.328-31.176 16.560-30.024 19.224-29.808C22.680-29.520 25.488-28.152 27.720-25.776C29.952-23.400 31.104-20.592 31.104-17.208C31.104-13.752 29.880-10.800 27.360-8.280C24.912-5.760 21.960-4.536 18.504-4.536C13.824-4.536 9.576-7.056 7.488-11.016L8.568-11.736C10.728-7.776 14.040-5.832 18.504-5.832C21.600-5.832 24.264-6.912 26.496-9.144C28.728-11.376 29.808-14.112 29.808-17.208C29.808-20.160 28.728-22.752 26.640-24.912C24.552-27.144 22.104-28.368 19.152-28.584C16.200-28.800 13.752-30.024 11.664-32.256C9.576-34.488 8.568-37.080 8.568-40.104C8.568-43.344 9.720-46.080 11.952-48.312C14.184-50.616 16.920-51.768 20.160-51.768C25.128-51.768 29.448-48.456 31.104-43.848ZM25.272-40.392C25.056-43.056 22.824-45.288 20.160-45.288C17.352-45.288 15.048-42.912 15.048-40.104C15.048-37.296 17.208-35.136 19.872-34.920C24.336-34.560 28.152-32.760 31.320-29.520C34.632-26.064 36.288-21.960 36.288-17.208C36.288-12.312 34.560-8.136 31.032-4.608C27.576-1.152 23.400 0.576 18.504 0.576C12.168 0.576 6.408-2.808 3.168-8.064L4.320-8.784C7.488-3.384 12.240-0.720 18.504-0.720C23.040-0.720 26.928-2.304 30.168-5.544C33.408-8.784 34.992-12.672 34.992-17.208C34.992-21.672 33.480-25.416 30.528-28.512C27.576-31.608 23.976-33.336 19.728-33.696C16.200-33.984 13.680-36.648 13.680-40.104C13.680-43.776 16.632-46.584 20.160-46.584C23.328-46.584 26.064-44.136 26.568-41.184ZM27.720-41.832C27.072-45.288 23.832-47.880 20.160-47.880C18.072-47.880 16.200-47.088 14.688-45.576C13.176-44.064 12.384-42.192 12.384-40.104C12.384-36.072 15.480-32.760 19.584-32.400C23.472-32.040 26.784-30.456 29.520-27.576C32.328-24.768 33.696-21.312 33.696-17.208C33.696-13.032 32.184-9.432 29.232-6.408C26.280-3.456 22.680-1.944 18.504-1.944C12.888-1.944 8.496-4.464 5.328-9.504L6.408-10.296C8.784-6.048 13.392-3.240 18.504-3.240C22.320-3.240 25.632-4.608 28.296-7.344C31.032-10.080 32.400-13.392 32.400-17.208C32.400-20.880 31.176-24.048 28.728-26.640C26.280-29.304 23.184-30.744 19.440-31.104C17.136-31.320 15.192-32.328 13.536-34.056C11.952-35.784 11.160-37.800 11.160-40.104C11.160-42.624 12.024-44.712 13.752-46.512C15.552-48.312 17.640-49.176 20.160-49.176C24.264-49.176 27.792-46.440 28.872-42.480ZM32.328-44.424C30.600-49.536 25.632-53.064 20.160-53.064C16.632-53.064 13.536-51.768 11.016-49.248C8.496-46.728 7.200-43.632 7.200-40.104C7.200-36.720 8.352-33.840 10.584-31.392C12.888-28.944 15.696-27.576 18.936-27.288C21.600-27.072 23.904-25.992 25.704-24.048C27.576-22.176 28.512-19.872 28.512-17.208C28.512-14.400 27.504-12.024 25.560-10.080C23.616-8.136 21.312-7.128 18.504-7.128C14.400-7.128 11.448-8.928 9.648-12.456L10.728-13.248C12.384-10.008 14.976-8.424 18.504-8.424C20.880-8.424 22.968-9.288 24.624-11.016C26.352-12.744 27.216-14.832 27.216-17.208C27.216-19.512 26.424-21.528 24.768-23.184C23.184-24.912 21.240-25.848 18.864-26.064C15.264-26.352 12.240-27.864 9.720-30.528C7.272-33.192 6.048-36.432 6.048-40.104C6.048-44.064 7.416-47.376 10.152-50.184C12.888-52.992 16.200-54.360 20.160-54.360C26.208-54.360 31.392-50.616 33.408-45.144Z"></path><path d="M56.239-15.192L55.663-13.896L76.327-13.896L75.823-15.192ZM57.175-17.784L56.671-16.488L75.319-16.488L74.887-17.784ZM73.375-21.672L66.031-40.320L58.759-21.672ZM58.255-20.376L57.751-19.080L74.311-19.080L73.879-20.376ZM77.407-11.376L76.903-12.600L55.231-12.600L54.727-11.376ZM54.223-10.080L50.263 0L48.895 0L70.927-56.304L72.367-56.304L94.327 0L92.887 0L71.575-54.576L70.927-52.848L91.447 0L90.079 0L70.207-50.976L69.559-49.248L88.783 0L87.343 0L68.839-47.520L68.191-45.720L86.047 0L84.607 0L67.471-43.992L66.823-42.048L83.167 0L81.799 0L77.911-10.080ZM69.487-56.304L47.455 0L46.015 0L68.119-56.304ZM66.751-56.304L44.719 0L43.279 0L65.383-56.304ZM64.015-56.304L41.983 0L40.543 0L62.503-56.304ZM61.063-56.304L39.175 0L37.735 0L59.695-56.304Z"></path><path d="M123.350-20.232L105.998-56.304L107.366-56.304L118.814-32.400L130.262-56.304L131.630-56.304L119.462-30.960L120.110-29.664L132.998-56.304L134.366-56.304L120.758-28.296L121.406-26.928L135.662-56.304L137.030-56.304L122.054-25.560L122.702-24.264L138.398-56.304L139.766-56.304L123.350-22.896L123.998-21.600L141.206-56.304L142.574-56.304L124.646-20.232L124.646 0L123.350 0ZM122.054 0L120.758 0L120.758-20.232L103.262-56.304L104.630-56.304L122.054-20.232ZM119.462 0L118.166 0L118.166-20.232L100.598-56.304L101.966-56.304L119.462-20.232ZM116.870 0L115.574 0L115.574-20.232L97.862-56.304L99.230-56.304L116.870-20.232ZM114.278 0L112.982 0L112.982-20.232L95.054-56.304L96.422-56.304L114.278-20.232Z"></path><path d="M145.822-56.304L145.822 0L144.526 0L144.526-56.304ZM153.598-56.304L153.598 0L152.302 0L152.302-56.304ZM151.006-56.304L151.006 0L149.710 0L149.710-56.304ZM148.414-56.304L148.414 0L147.118 0L147.118-56.304ZM156.190-24.984L156.190-23.688L171.814-23.688L171.814-22.392L156.190-22.392L156.190-11.664L177.214-11.664L177.214-10.368L156.190-10.368L156.190-9.072L177.214-9.072L177.214-7.776L156.190-7.776L156.190-6.480L177.214-6.480L177.214-5.184L156.190-5.184L156.190-3.888L177.214-3.888L177.214-2.592L156.190-2.592L156.190-1.296L177.214-1.296L177.214 0L154.894 0L154.894-56.304L177.214-56.304L177.214-55.008L156.190-55.008L156.190-53.712L177.214-53.712L177.214-52.416L156.190-52.416L156.190-51.120L177.214-51.120L177.214-49.824L156.190-49.824L156.190-48.528L177.214-48.528L177.214-47.232L156.190-47.232L156.190-45.936L177.214-45.936L177.214-44.712L156.190-44.712L156.190-34.056L171.814-34.056L171.814-32.760L156.190-32.760L156.190-31.464L171.814-31.464L171.814-30.168L156.190-30.168L156.190-28.872L171.814-28.872L171.814-27.576L156.190-27.576L156.190-26.280L171.814-26.280L171.814-24.984Z"></path><path d="M210.269-45.792C207.893-51.624 202.205-55.656 195.797-55.656C191.549-55.656 187.949-54.144 184.853-51.048C181.757-48.024 180.245-44.352 180.245-40.104C180.245-36.072 181.613-32.616 184.277-29.664C187.013-26.784 190.397-25.128 194.357-24.768C198.605-24.408 201.557-21.240 201.557-17.208C201.557-13.104 198.245-9.720 194.141-9.720C191.045-9.720 188.813-11.160 187.445-14.040L188.525-14.688C189.533-12.240 191.405-11.016 194.141-11.016C197.525-11.016 200.261-13.824 200.261-17.208C200.261-20.448 197.597-23.184 194.357-23.472C190.109-23.832 186.437-25.560 183.485-28.728C180.533-31.968 179.021-35.712 179.021-40.104C179.021-44.784 180.677-48.744 183.917-51.984C187.157-55.296 191.117-56.952 195.797-56.952C202.709-56.952 208.757-52.632 211.349-46.512ZM205.733-43.200C204.365-47.520 200.405-50.472 195.797-50.472C192.989-50.472 190.541-49.464 188.453-47.376C186.437-45.360 185.429-42.912 185.429-40.104C185.429-37.440 186.365-35.064 188.165-33.120C189.965-31.176 192.197-30.024 194.861-29.808C198.317-29.520 201.125-28.152 203.357-25.776C205.589-23.400 206.741-20.592 206.741-17.208C206.741-13.752 205.517-10.800 202.997-8.280C200.549-5.760 197.597-4.536 194.141-4.536C189.461-4.536 185.213-7.056 183.125-11.016L184.205-11.736C186.365-7.776 189.677-5.832 194.141-5.832C197.237-5.832 199.901-6.912 202.133-9.144C204.365-11.376 205.445-14.112 205.445-17.208C205.445-20.160 204.365-22.752 202.277-24.912C200.189-27.144 197.741-28.368 194.789-28.584C191.837-28.800 189.389-30.024 187.301-32.256C185.213-34.488 184.205-37.080 184.205-40.104C184.205-43.344 185.357-46.080 187.589-48.312C189.821-50.616 192.557-51.768 195.797-51.768C200.765-51.768 205.085-48.456 206.741-43.848ZM200.909-40.392C200.693-43.056 198.461-45.288 195.797-45.288C192.989-45.288 190.685-42.912 190.685-40.104C190.685-37.296 192.845-35.136 195.509-34.920C199.973-34.560 203.789-32.760 206.957-29.520C210.269-26.064 211.925-21.960 211.925-17.208C211.925-12.312 210.197-8.136 206.669-4.608C203.213-1.152 199.037 0.576 194.141 0.576C187.805 0.576 182.045-2.808 178.805-8.064L179.957-8.784C183.125-3.384 187.877-0.720 194.141-0.720C198.677-0.720 202.565-2.304 205.805-5.544C209.045-8.784 210.629-12.672 210.629-17.208C210.629-21.672 209.117-25.416 206.165-28.512C203.213-31.608 199.613-33.336 195.365-33.696C191.837-33.984 189.317-36.648 189.317-40.104C189.317-43.776 192.269-46.584 195.797-46.584C198.965-46.584 201.701-44.136 202.205-41.184ZM203.357-41.832C202.709-45.288 199.469-47.880 195.797-47.880C193.709-47.880 191.837-47.088 190.325-45.576C188.813-44.064 188.021-42.192 188.021-40.104C188.021-36.072 191.117-32.760 195.221-32.400C199.109-32.040 202.421-30.456 205.157-27.576C207.965-24.768 209.333-21.312 209.333-17.208C209.333-13.032 207.821-9.432 204.869-6.408C201.917-3.456 198.317-1.944 194.141-1.944C188.525-1.944 184.133-4.464 180.965-9.504L182.045-10.296C184.421-6.048 189.029-3.240 194.141-3.240C197.957-3.240 201.269-4.608 203.933-7.344C206.669-10.080 208.037-13.392 208.037-17.208C208.037-20.880 206.813-24.048 204.365-26.640C201.917-29.304 198.821-30.744 195.077-31.104C192.773-31.320 190.829-32.328 189.173-34.056C187.589-35.784 186.797-37.800 186.797-40.104C186.797-42.624 187.661-44.712 189.389-46.512C191.189-48.312 193.277-49.176 195.797-49.176C199.901-49.176 203.429-46.440 204.509-42.480ZM207.965-44.424C206.237-49.536 201.269-53.064 195.797-53.064C192.269-53.064 189.173-51.768 186.653-49.248C184.133-46.728 182.837-43.632 182.837-40.104C182.837-36.720 183.989-33.840 186.221-31.392C188.525-28.944 191.333-27.576 194.573-27.288C197.237-27.072 199.541-25.992 201.341-24.048C203.213-22.176 204.149-19.872 204.149-17.208C204.149-14.400 203.141-12.024 201.197-10.080C199.253-8.136 196.949-7.128 194.141-7.128C190.037-7.128 187.085-8.928 185.285-12.456L186.365-13.248C188.021-10.008 190.613-8.424 194.141-8.424C196.517-8.424 198.605-9.288 200.261-11.016C201.989-12.744 202.853-14.832 202.853-17.208C202.853-19.512 202.061-21.528 200.405-23.184C198.821-24.912 196.877-25.848 194.501-26.064C190.901-26.352 187.877-27.864 185.357-30.528C182.909-33.192 181.685-36.432 181.685-40.104C181.685-44.064 183.053-47.376 185.789-50.184C188.525-52.992 191.837-54.360 195.797-54.360C201.845-54.360 207.029-50.616 209.045-45.144Z"></path></g></g></svg></svg>
      </div>
      
    <div class="menu" v-on:click="popup()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z" /></svg>
    </div>

    <div id="popupstats"  v-bind:class="{popupstats: popupStats}">
        <div class="container-stats">
            <div class="stats-title">ESTADISTICAS</div>
            <div class="stats-item">Participantes <span>{{ stats.participantes }}</span></div> 
            <div class="stats-item">Participado <span>{{stats.participado }}</span></div>
            <div class="stats-item">Votos positivos <span>{{loadEvent.positivos }}</span></div>
            <div class="stats-item">Votos negativos <span>{{loadEvent.negativos }}</span></div>
            <div class="stats-item"> % participacion <span>{{ (((loadEvent.negativos + loadEvent.positivos) * 100) /  stats.participantes).toFixed(2) }}%</span></div>
            <div class="stats-item">% positivo <span>{{ ((loadEvent.positivos * 100) / stats.participado).toFixed(2) }}%</span></div>
            <div class="stats-item">% negativo <span>{{ ((loadEvent.negativos * 100) / stats.participado).toFixed(2) }}%</span></div>
            <svg class="close-pop" @click="popupStatsM()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/></svg>
        </div>
    </div>

    <!-- POPUP -->
    <div id="popupuser" v-bind:class="{popupuser: popupUser}">
        <div class="popuser-container">
            <div class="popup-header"> Info cuenta </div>
            <div class="user">
                <div class="user-email">{{user.name}}</div>
                <div class="user-email">{{user.email}}</div>
                <div class="change-name">
                    <!-- <input type="text" :placeholder="user.name" v-model="user.name"> -->
                    <!-- <button @click="updateName()">Actualizar</button> -->
                </div>
            </div>
            <div class="logout">
                <div class="logout--title">Logout</div>
                <a href="#" @click="logout">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16 9v-4l8 7-8 7v-4h-8v-6h8zm-2 10v-.083c-1.178.685-2.542 1.083-4 1.083-4.411 0-8-3.589-8-8s3.589-8 8-8c1.458 0 2.822.398 4 1.083v-2.245c-1.226-.536-2.577-.838-4-.838-5.522 0-10 4.477-10 10s4.478 10 10 10c1.423 0 2.774-.302 4-.838v-2.162z"/></svg>
                </a>  
            </div>
        </div>
    </div>

    <!-- CONTENEDOR PRINCIPAL -->
    <div class="main">
        <div class="main-aside">
            <ul>
                <li v-for="(event, index) in user.eventList2" :key="index" class="container-events">
                    <div class="event-item" @click="selectEvent(event)">
                        <p class="container-events--title">{{event.title}}</p>
                        <p class="container-events--description">{{event.description}}</p>
                        <!-- <p class="container-events--description">{{event.id}}</p> -->
                    </div>
                </li>
            </ul> 
        </div>
        <div class="main-col">
            <div class="main-col--container">
                <!-- Enjoy Event-->
                <div class="main-join">
                    <button  v-on:click="createEvent = !createEvent" @click="openJoin = false">CREAR</button>
                    <button v-on:click="openJoin = !openJoin" @click="createEvent = false">UNIRSE</button>
                </div>

                <!-- Create Event-->
                <div class="main-create">
                    <div v-if="createEvent" class="main-create--container">
                        <input v-model="newEvent.title" type="text" placeholder="Nombre evento*">
                        <input v-model="newEvent.description" type="text" placeholder="Descripción">
                        <input class="main-create--date" type="date" v-model="newEvent.date" placeholder="Finalización votación">

                        <!-- <input type="date" placeholder="fin"> -->
                        <button v-on="randomId()" v-on:click="createdEvent()">Crear evento</button>
                    </div>

                    <div v-else-if="openJoin" class="main-create--join">
                        <input type="text" name="join" placeholder="Code to join" v-model="joincode">
                        <button @click="joinEvent()">Join</button>
                    </div>

                    <div v-else class="main-create--msg">
                        <div v-if="msg.length > 40" class="delete-msg"> 
                            <div>{{msg}}</div> 
                            <span class="delete-event" @click="deleteEvent()">Borrar evento</span>
                        </div>

                        <div v-else-if="msg.length > 11"> {{msg}}  </div>

                        <div v-else-if="msg.length <= 11 && msg.length > 1 " class="container-copy">
                            <span class="delete-event" @click="deleteEvent()">Borrar evento</span>
                            <div class="container-copy--img">
                                {{msg}} 
                                <button class="btn-copy" type="button" v-clipboard:copy="msg" v-clipboard:success="onCopy" v-clipboard:error="onError">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-copy" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><rect x="8" y="8" width="12" height="12" rx="2" /><path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" /></svg>
                                </button>
                            </div>
                        </div>

                    <div v-else> Info </div>
                    </div>
                </div>
            </div>

            <!-- Eventos -->
            <div class="main-event">

                <div class="main-event--header">
                    <div class="main-event--header--title">{{ loadEvent.title }}</div>
                    <div class="main-event--header--description">{{loadEvent.description}}</div>
                    <div class="main-event--header--description">{{loadEvent.date}}</div>
                </div>

                <div class="main-event--users">
                    <div class="main-event--users--title">Participantes</div>
                    <ul>
                        <li v-for="users in loadEvent.users" :key="users"> 
                            {{users}}
                        </li>
                    </ul>
                    <div class="stats" v-on:click="popupStatsM()">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill='#FFFFFF'><path d="M4 12h4v10H4zM10 4h4v18h-4zM16 8h4v14h-4z"></path></g></svg>
                    </div>
                </div>

                <div class="main-event--body">
                    <div class="positivos">
                        <ul>
                            <li>Positivos</li>
                            <li v-for="item in loadEvent.usersPositivos" :key="item"> {{item}}</li>
                        </ul>
                    </div>
                    <div class="negativos">
                        <ul>
                            <li>Negativos</li>
                            <li v-for="item in loadEvent.usersNegativos" :key="item"> {{item}}</li>
                        </ul>
                    </div>
                </div>
                
                <div class="vote" :class="{ nosevotamas: loadEvent.timeOut }">
                    <button @click="voteYes()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon-yes" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/>  <circle cx="12" cy="12" r="9" />  <line x1="9" y1="10" x2="9.01" y2="10" /><line x1="15" y1="10" x2="15.01" y2="10" /><path d="M9.5 15a3.5 3.5 0 0 0 5 0" /></svg>
                    </button>
                    <button @click="voteNo()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon-no" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><circle cx="12" cy="12" r="9" /><line x1="9" y1="10" x2="9.01" y2="10" /><line x1="15" y1="10" x2="15.01" y2="10" /> <path d="M9.5 16a10 10 0 0 1 6 -1.5" /></svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- CONTENEDOR PRINCIPAL FIN -->

  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

export default {
  name: 'HelloWorld',
  data() {
    return {
      user: {
            name: "",
            email: "",
            img: "",
            idEmail:"",
            eventList: [],
            eventList2: []
      },
      newEvent: {
            title:"",
            description: "",
            date: "",
            code:""
      },
      loadEvent: {
            title:"",
            description: "",
            date: "",
            today: "",
            code:"",
            users: [],
            usersNegativos: [],
            usersPositivos: [],
            positivos: [],
            negativos: [],
            timeOut: false,
      },
      stats: {
            participantes:'',
            participado: '',
      },
      createEvent: false,
      openJoin: false,
      msg: '',
      popupUser: true,
      popupStats: true,
      joincode: '',
      eventSelect: '',
    }
  },
  //Cuando todo esta creado
  mounted: function () {
        this.loadEvents();
        this.registerUser();

        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        //console.log(year,month,day)
        if(month < 10) {
            month = "0"+month;
            //console.log(month)
        }
        if(day < 10) {
            day = "0"+day;
            //console.log(day)
        }
        this.loadEvent.today = year+""+month+""+day;
        //console.log(this.loadEvent.today )
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(()=> this.$router.replace('login'));
    },
    randomId() {
        let characters  = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
        let charactersLength = characters.length;
        let randomLong = 3;
        var randId = "";
        for ( var i = 0; i < randomLong; i++ ) {
            randId += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        this.newEvent.code = randId;
    },
    createdEvent() {

        if(this.newEvent.title != '') {
            var eventos = this.$db.collection('events');
            let usuario = firebase.auth().currentUser;
            var userRef = this.$db.collection('users').doc(usuario.email);

            eventos.doc(this.newEvent.code).set({
                id:this.newEvent.code,
                title: this.newEvent.title,
                date:this.newEvent.date,
                description: this.newEvent.description
            });

            eventos.doc(this.newEvent.code).collection('users').doc(usuario.email).set({
                nombre: usuario.displayName,
                votacion: false,
                votado:''
            })
        
            userRef.update({
                events:firebase.firestore.FieldValue.arrayUnion(this.newEvent.code)
            })

            this.newEvent.title = '';
            this.newEvent.description = '';
            this.createEvent = false;
            this.msg = 'Evento creado correctamente'

            this.user.eventList = [];
            this.loadEvents();
        } else {
            this.msg = "Evento no creado, motivo: titulo vacio, intentelo de nuevo"
            this.createEvent = false;
        }
        
    },
    deleteEvent() {
        
        let usuario = firebase.auth().currentUser;
        var emailRef = this.$db.collection('users').doc(usuario.email);

        emailRef.update({
            events:firebase.firestore.FieldValue.arrayRemove(this.loadEvent.id)
        })

        this.msg = "Evento borrado con exito";
        this.loadEvent.title = "Hasta la vista";
        this.loadEvent.description = "";
        this.loadEvent.users = [];
        this.loadEvent.usersPositivos = [];
        this.loadEvent.usersNegativos = [];

        this.loadEvents();

    },
    loadEvents() {

        /* reseteamos la lista */
        
        this.user.eventList = []; // cogemos el array donde estan todos los eventos de cada usuario
        this.user.eventList2 = [];

        let usuario = firebase.auth().currentUser;

        // Rescatamos en users los eventos
        this.$db.collection("users").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
               if(doc.id == usuario.email) {
                   this.user.eventList = doc.data().events
               }
            });
        });

        // Aqui nos sale los datos de la gente y su votación
        this.$db.collection("events").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                for (let index = 0; index < this.user.eventList.length; index++) {
                    if(doc.data().id == this.user.eventList[index] ) {
                       this.user.eventList2.push(doc.data());
                    }
                }
            });
        });

    },
    selectEvent(event) {
        
        this.loadEvent.users = []; // ponemos la lista de usuarios a cero para que se rellene de nuevo
        this.eventSelect = event.id;
        let positivos = 0;
        let negativos = 0;

        /* Recogemos los datos del evento y los pintamos */
        this.$db.collection("events").doc(event.id).get()
        .then( (doc) => {
            //console.log(doc.data())
            this.loadEvent.title = doc.data().title;
            this.loadEvent.description = doc.data().description;
            this.loadEvent.date = doc.data().date;
            this.loadEvent.id = doc.data().id;
            this.loadEvent.usersPositivos = doc.data().positivos;
            this.loadEvent.usersNegativos = doc.data().negativos;
            this.msg = doc.data().id        

            if(doc.data().hasOwnProperty('positivos')) {
                positivos = doc.data().positivos.length;
            } else {
             //   console.log("no tiene positivos")
            }

            if(doc.data().hasOwnProperty('negativos')) {
                negativos = doc.data().negativos.length;
            } else {
               // console.log("no tiene negativos")
            }

            this.loadEvent.positivos = positivos;
            this.loadEvent.negativos = negativos;
    
            this.stats.participado = positivos + negativos;

 
            this.loadEvent.date = this.loadEvent.date.substring(0,4)+""+this.loadEvent.date.substring(5,7)+""+this.loadEvent.date.substring(8,10)
            //console.log(this.loadEvent.date)


            if(this.loadEvent.today > this.loadEvent.date ) {
                console.log(this.loadEvent.today+ " es mayor que "+this.loadEvent.date)
                console.log("No se podria votar")
                this.msg = "Lo sentimos pero se pasó la fecha para poder votar"
                this.loadEvent.timeOut = true;
            } else {
                console.log(this.loadEvent.date+" la fecha de hoy es mayor "+this.loadEvent.today)
                console.log("Puedes votar")
                this.loadEvent.timeOut = false;
            }
            
        })

        /* Ponemos una escucha en las votaciones para que se actualice al instante */
        this.$db.collection("events").doc(event.id)
        .onSnapshot( (doc) => {
            this.loadEvent.positivos = positivos;
            this.loadEvent.negativos = negativos;
        })


        /* Recogemos los nombres de los usuarios del evento señalado */
        this.$db.collection("events").doc(event.id).collection('users').get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                this.loadEvent.users.push(doc.data().nombre) 
            });
            this.stats.participantes = this.loadEvent.users.length;
        })
        
    },
    voteYes() {
        let usuario = firebase.auth().currentUser;
        var userRef = this.$db.collection('users').doc(usuario.email);

        // agregamos el dato en events doc users doc
        var collectionRef = this.$db.collection("events").doc(this.eventSelect).collection('users').doc(usuario.email);
        collectionRef.update({
            votacion:'yes'
        })

        /* lo metemos dentro del documento events para imprimir el listado de los positivos*/
        var collectionRef = this.$db.collection("events").doc(this.eventSelect);
        collectionRef.update({
            positivos:firebase.firestore.FieldValue.arrayUnion(usuario.displayName),
            negativos:firebase.firestore.FieldValue.arrayRemove(usuario.displayName)
        })

        // Volvemos a imprimir las votaciones para que se actualice
        this.$db.collection("events").doc(this.eventSelect).get()
        .then( (doc) => {
            this.loadEvent.usersPositivos = []
            this.loadEvent.usersNegativos = []
            this.loadEvent.usersPositivos = doc.data().positivos;
            this.loadEvent.usersNegativos = doc.data().negativos;
        })

    },
    voteNo() {
        let usuario = firebase.auth().currentUser;
        var userRef = this.$db.collection('users').doc(usuario.email);

        // Aqui nos sale los datos de los users y su votación 
        var collectionRef = this.$db.collection("events").doc(this.eventSelect).collection('users').doc(usuario.email);
        collectionRef.update({
            votacion:'no'
        })

        /* lo metemos dentro del documento events para imprimir el listado de los positivos*/
        var collectionRef = this.$db.collection("events").doc(this.eventSelect);
        collectionRef.update({
            negativos:firebase.firestore.FieldValue.arrayUnion(usuario.displayName),
            positivos:firebase.firestore.FieldValue.arrayRemove(usuario.displayName)
        })

        // Volvemos a imprimir las votaciones para que se actualice
        this.$db.collection("events").doc(this.eventSelect).get()
        .then( (doc) => {
            this.loadEvent.usersPositivos = []
            this.loadEvent.usersNegativos = []
            this.loadEvent.usersPositivos = doc.data().positivos;
            this.loadEvent.usersNegativos = doc.data().negativos;
        })
    },
    joinEvent() {
        var eventRef = this.$db.collection('events').doc(this.joincode);
        
        let usuario = firebase.auth().currentUser;
        //console.log(usuario.displayName)
        var userRef = this.$db.collection('users').doc(usuario.email);

        eventRef.get()
        .then((docSnapshot) => {
            if (docSnapshot.exists) {
                eventRef.onSnapshot((doc) => {
                    /* añadimos el user a eventos -> users*/
                    eventRef.collection('users').doc(usuario.email).set({
                        nombre: usuario.displayName,
                        votacion: false,
                        votado:''
                    })

                    /* añadimos a users el evento */
                    userRef.update({
                        events:firebase.firestore.FieldValue.arrayUnion(this.joincode)
                    })

                    this.joincode = '';

                    this.user.eventList = [];
                    this.loadEvents();
                    
                });
            } else {
                console.log('El evento no existe')
                //eventRef.set({...}) // create the document
                this.openJoin = !this.openJoin;
                this.msg = "El evento no existe";
            }
        });
    },
    registerUser() {
        var user = firebase.auth().currentUser;
        var ref = this.$db.collection('users').doc(user.email);
        this.user.name = user.displayName;
        this.user.email = user.email;

        ref.get().then(docSnapshot => {
            if (docSnapshot.exists) {
                //console.log('existe')
            } else {
               // console.log('No existe y lo creamos')
                ref.set({
                    name: user.displayName,
                    email: user.email,
                    photoUrl: user.photoURL,
                    emailVerified: user.emailVerified,
                    uid: user.uid
                })
            }
        })
    },
    popup() {
        this.popupUser = !this.popupUser;
    },
    popupStatsM() {
        this.popupStats = !this.popupStats;
    },
    updateName() {
        var user = firebase.auth().currentUser;

        user.updateProfile({
            displayName: this.user.name
        }).then(function () {
            // Update successful.
        })

        var userRef = this.$db.collection('users').doc(user.email);

        userRef.set({
            name: this.user.name
        }, { merge: true });

        var eventsRef = this.$db.collection('events').doc

    },
    onCopy(e) {
      console.log('You just copied: ' + e.text)
    },
    onError(e) {
      console.log('Failed to copy texts')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/assets/styles/main.scss';
</style>
